import { createSlice, createEntityAdapter, PayloadAction } from '@reduxjs/toolkit';
import { Row } from '../../types/Spreadsheet';
import { RootState } from '../store';
import { InsertRowsPayload } from './types';

const rowsAdapter = createEntityAdapter({
    selectId: ( row: Row ) => row.id
    // sortComparer: ( a, b ) => a.id.localeCompare( b.id )
});

const initialState = rowsAdapter.getInitialState();

const rowsSlice = createSlice({
    name: 'rows',
    initialState,
    reducers: {
        setRows: rowsAdapter.setAll,
        addRow: rowsAdapter.addOne,
        addRows: rowsAdapter.addMany,
        updateRow: rowsAdapter.updateOne,
        removeRow: rowsAdapter.removeOne,
        updateRows: rowsAdapter.updateMany,
        removeRows: rowsAdapter.removeMany,
        upsertRow: rowsAdapter.upsertOne,
        upsertRows: rowsAdapter.upsertMany,
        removeAllRows: rowsAdapter.removeAll,
        insertRowsAtIndex: ( state, action: PayloadAction<InsertRowsPayload> ) => {
            const { index, newRows } = action.payload;
            const allRows = rowsAdapter.getSelectors().selectAll( state );
            allRows.splice( index, 0, ...newRows );
            rowsAdapter.setAll( state, allRows );
        }
    }
});

export const {
    setRows,
    addRow,
    addRows,
    updateRow,
    removeRow,
    updateRows,
    removeRows,
    upsertRow,
    upsertRows,
    removeAllRows,
    insertRowsAtIndex
} = rowsSlice.actions;

export default rowsSlice.reducer;

export const {
    selectAll: selectAllRows,
    selectById: selectRowById,
    selectIds: selectRowIds,
    selectEntities: selectRowEntities
} = rowsAdapter.getSelectors<RootState>(( state ) => state.spreadsheet.rows );